export const url = process.env.VUE_APP_PAGE_DOMAIN_URL ?? ''
